import tag from '@/components/Tag.vue';
import crumbs from '@/components/Crumbs.vue';
import meun from '../components/Meun.vue';
import mains from './Main.vue';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import { SwitchButton, User } from '@element-plus/icons-vue';
export default {
  components: {
    meun: meun,
    // 侧边菜单组件
    mains: mains,
    // 二级路由组件
    crumbs: crumbs,
    // 面包屑组件
    tag: tag,
    // 标签页组件
    User: User,
    SwitchButton: SwitchButton
  },
  data: function data() {
    return {
      locale: zhCn,
      //国际化，组件英文汉化
      isCollapse: false // 折叠菜单的数据

    };
  },
  methods: {
    // 退出登录
    retreat: function retreat() {
      ElMessageBox.confirm('确定退出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        ElMessage({
          type: 'success',
          message: '退出成功!'
        });
      }).catch(function () {
        ElMessage({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};